import { SectionDivider } from "./SectionDivider";
import ContactUsPage from "app/contact-us/contactUspage";
import { Box } from "@chakra-ui/react";
const TalkToUs = () => {
  return (
    <Box id="contact-form">
      <SectionDivider label="Talk To Us" />
      <ContactUsPage />
    </Box>
  );
};

export default TalkToUs;
